import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cseHeaderButton = {
  gap: css`var(--cse-header-button-gap, ${csSpacing.spacing04})`,
  color: css`var(--cse-header-button-color, ${csColorText.body})`,
  colorDisabled: css`var(--cse-header-button-color-disabled, ${csColorText.muted})`,

  iconColor: css`var(--cse-header-button-icon-color, ${csColorAction.linkSecondary})`,
  iconColorHover: css`var(--cse-header-button-icon-color-hover, ${csColorAction.linkSecondaryHover})`,

  badgePositionTop: css`var(--cse-header-button-badge-position-top, -9px)`,
  badgePositionLeft: css`var(--cse-header-button-badge-position-left, 14px)`,
}

export const style: CSSResult = css`
  .cse-header-button {
    --cse-text-color: ${cseHeaderButton.color};
    align-items: center;
    background: none;
    border: none;
    color: ${cseHeaderButton.iconColor};
    display: inline-flex;
    flex-direction: column;
    font-size: inherit;
    gap: ${cseHeaderButton.gap};
    padding: 0;
    text-decoration: none;
  }

  .cse-header-button:hover {
    color: ${cseHeaderButton.iconColorHover};
    cursor: pointer;
  }

  .cse-header-button.disabled {
    --cse-text-color: ${cseHeaderButton.colorDisabled};

    color: ${cseHeaderButton.colorDisabled};
    cursor: not-allowed;
  }

  .icon-wrapper {
    position: relative;
  }

  cse-badge {
    position: absolute;
    top: ${cseHeaderButton.badgePositionTop};
    left: ${cseHeaderButton.badgePositionLeft};
  }

  .inline cse-badge {
    position: initial;
    transform: translate(0, ${cseHeaderButton.badgePositionTop});
    margin-left: -12px;
    display: inline-block;
  }

  .cse-header-button.inline {
    flex-direction: row;
  }
`
